<template>
  <div v-editable="blok" class="storyblok-faq">
    <StoryblokComponent
      v-for="questionBlok in questionBloks"
      :key="questionBlok._uid"
      :blok="questionBlok"
    />
  </div>
</template>

<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue';
import { computed } from 'vue';
import type { StoryblokFaqBlok } from '@/features/storyblok/types';

const props = defineProps<{
  blok: StoryblokFaqBlok;
}>();

const questionBloks = computed(() => props.blok.questions ?? props.blok.Questions ?? []);
</script>

<style scoped>
.storyblok-faq {
  display: flex;
  flex-direction: column;
  gap: var(--ion-space-3);
  width: 100%;
}
</style>
